module.exports = {
      id: "automobile-usage",
      viewBox: "0 0 31.664 23.083",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#automobile",
      toString: function () {
        return this.url;
      }
    }